import List from '../views/statuses/list'

export default [
    {
        path: '/admin/project/:project_id/statuses',
        name: 'statuses',
        component: List,
    }
]
